import React, { Component, Fragment } from "react";
import Breadcrumb from "../../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import { ToastContainer, toast } from "react-toastify";
import CountUp from "react-countup";
import { connect } from "react-redux";
import {
  getAllSourcingsAgentRedux,
  getAllEmployeeRedux,
  handleSourcingAgentPayRedux,
} from "../../../../actions";
import "./monthly-invoice.css";
import AllTransactions from "./allTransactions";

const sumRefundArray = (arr) =>
  (arr || []).reduce((sum, r) => sum + (parseFloat(r.amount) || 0), 0);

// Refund given (Tk) and refund taken (RMB, converted to Tk via the
// invoice's buy rate) for a single invoice.
const getRefundTotals = (sourcing) => ({
  given: sumRefundArray(sourcing.givenRefund),
  taken:
    sumRefundArray(sourcing.receivedRefund) *
    (parseFloat(sourcing.buyRate) || 0),
});

export class MonthlyInvoices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sourcingObj: null,
      filterCountry: "",
      selectedTab: "month",
      agentPaid: 0,
    };
  }

  componentDidMount = async () => {
    const { agent, month } = this.props.match.params;
    this.props.getAllEmployeeRedux();
    this.props.getAllSourcingsAgentRedux(agent, month);
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  getMonthName = () => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const d = new Date();
    return `${monthNames[d.getMonth()]},${d.getFullYear()}`;
  };

  handleCashOut = async () => {
    const { currentAdmin } = this.props;
    let date = new Date();
    if (!this.state.agentPaid) {
      alert("Please enter an amount first");
      return;
    }
    console.log(this.state.agentPaid);
    this.props.handleSourcingAgentPayRedux({
      ...this.state.sourcingObj,
      agentPaid: this.state.agentPaid,
      paymentId: date.getTime().toString(),
      month: this.getMonthName(),
      date: date.toLocaleDateString("en-GB"),
      receiveBy: currentAdmin.name,
      agentPays:
        this.state.sourcingObj.agentPays &&
        this.state.sourcingObj.agentPays.length > 0
          ? [
              {
                id: date.getTime().toString(),
                amount: this.state.agentPaid,
                date: date.toLocaleDateString("en-GB"),
                expenseBy: currentAdmin.name,
              },
              ...this.state.sourcingObj.agentPays,
            ]
          : [
              {
                id: date.getTime().toString(),
                amount: this.state.agentPaid,
                date: date.toLocaleDateString("en-GB"),
                expenseBy: currentAdmin.name,
              },
            ],
    });
    this.setState({
      agentPaid: 0,
    });
  };

  render() {
    const { sourcingObj } = this.state;
    const { sourcings, currentAdmin } = this.props;
    let date = new Date();
    let totalBill = 0;
    let totalRmb = 0;
    let totalPaid = 0;
    let buyingCost = 0;
    let totalProfit = 0;
    let sellRate = 0;
    let buyRate = 0;
    let shipping = 0;
    let totalRefundGiven = 0;
    let totalRefundReceived = 0;
    let totalRefundReceivedTk = 0;
    let totalOtherCharges = 0;
    let totalOtherChargesTk = 0;
    let renderablesourcings = [];

    if (
      sourcingObj &&
      sourcingObj.receivedRefund &&
      sourcingObj.receivedRefund.length > 0
    ) {
      sourcingObj.receivedRefund.map((refund) => {
        totalRefundReceived += parseFloat(refund.amount);
      });
      totalRefundReceivedTk = parseInt(
        totalRefundReceived * sourcingObj.buyRate,
      );
    }
    if (
      sourcingObj &&
      sourcingObj.otherCharges &&
      sourcingObj.otherCharges.length > 0
    ) {
      sourcingObj.otherCharges.map((refund) => {
        totalOtherCharges += parseFloat(refund.rmb);
      });
      totalOtherChargesTk = parseInt(totalOtherCharges * sourcingObj.buyRate);
    }
    if (
      sourcingObj &&
      sourcingObj.givenRefund &&
      sourcingObj.givenRefund.length > 0
    ) {
      sourcingObj.givenRefund.map((refund) => {
        totalRefundGiven += parseFloat(refund.amount);
      });
    }
    if (!this.state.filterCountry) {
      renderablesourcings = sourcings.filter((sourcing) => sourcing.agent);
    } else {
      renderablesourcings = sourcings
        .filter((sourcing) => sourcing.agent)
        .filter((sourcing) => sourcing.country === this.state.filterCountry);
    }
    let summaryRefundGiven = 0;
    let summaryRefundTaken = 0;
    if (renderablesourcings.length > 0) {
      renderablesourcings.map((sourcing) => {
        totalBill += parseInt(sourcing.totalBill || 0);
        totalRmb += parseInt(sourcing.totalRmb || 0);
        totalPaid += parseInt(sourcing.totalPaid || 0);
        buyingCost += parseInt(sourcing.buyingCost || 0);
        totalProfit += parseInt(sourcing.finalProfit || 0);
        sellRate += parseFloat(sourcing.sellRate || 0);
        buyRate += parseFloat(sourcing.buyRate || 0);
        shipping += parseFloat(sourcing.shipping || 0);
        const refundTotals = getRefundTotals(sourcing);
        summaryRefundGiven += refundTotals.given;
        summaryRefundTaken += refundTotals.taken;
      });
    }

    console.log(this.props);
    let employee = this.props.allEmployees.find(
      (employee) => employee.employeeId == this.props.match.params.agent,
    );
    return (
      <Fragment>
        <Breadcrumb
          title={this.props.match.params.agent}
          parent="Wholesale Management/Order"
        />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid">
          <div className="row" style={{ justifyContent: "center" }}>
            <div className="col-sm-12">
              <div className="consultancy-tab-strip">
                <button
                  type="button"
                  className={`consultancy-tab${
                    this.state.selectedTab === "month"
                      ? " consultancy-tab--active"
                      : ""
                  }`}
                  onClick={() => {
                    this.setState({ selectedTab: "month" });
                  }}
                >
                  <span className="consultancy-tab-label">
                    {this.props.match.params.month} invoices
                  </span>
                  <span className="consultancy-tab-value">
                    <CountUp className="counter" end={totalBill} />
                    <span className="consultancy-tab-unit">Tk</span>
                  </span>
                </button>
                <button
                  type="button"
                  className={`consultancy-tab${
                    this.state.selectedTab === "rmb"
                      ? " consultancy-tab--active"
                      : ""
                  }`}
                  onClick={() => {
                    this.setState({ selectedTab: "rmb" });
                  }}
                >
                  <span className="consultancy-tab-label">RMB balance</span>
                  <span className="consultancy-tab-value">
                    <CountUp
                      className="counter"
                      end={
                        employee && employee.rmbBalance
                          ? employee.rmbBalance
                          : 0
                      }
                    />
                    <span className="consultancy-tab-unit">Tk</span>
                  </span>
                </button>
                <button
                  type="button"
                  className={`consultancy-tab${
                    this.state.selectedTab === "rupee"
                      ? " consultancy-tab--active"
                      : ""
                  }`}
                  onClick={() => {
                    this.setState({ selectedTab: "rupee" });
                  }}
                >
                  <span className="consultancy-tab-label">
                    Rupee balance
                  </span>
                  <span className="consultancy-tab-value">
                    <CountUp
                      className="counter"
                      end={
                        employee && employee.rupeeBalance
                          ? employee.rupeeBalance
                          : 0
                      }
                    />
                    <span className="consultancy-tab-unit">Tk</span>
                  </span>
                </button>
              </div>
            </div>
            {this.state.selectedTab === "month" ? (
              <div className="col-sm-12">
                <div className="consultancy-summary-card">
                  <div className="consultancy-summary-header">
                    <span className="consultancy-summary-eyebrow">
                      {this.props.match.params.month}
                    </span>
                    <h4 className="consultancy-summary-title">
                      {this.props.match.params.agent} summary
                    </h4>
                  </div>
                  <div className="consultancy-summary-tiles">
                    <div className="consultancy-summary-tile">
                      <span className="consultancy-summary-label">
                        Total Rmb
                      </span>
                      <span className="consultancy-summary-value">
                        <CountUp className="counter" end={totalRmb} />
                        <span className="consultancy-summary-unit">Rmb</span>
                      </span>
                    </div>
                    <div className="consultancy-summary-tile">
                      <span className="consultancy-summary-label">
                        Total bill
                      </span>
                      <span className="consultancy-summary-value">
                        <CountUp className="counter" end={totalBill} />
                        <span className="consultancy-summary-unit">Tk</span>
                      </span>
                    </div>
                    <div className="consultancy-summary-tile">
                      <span className="consultancy-summary-label">
                        Total paid
                      </span>
                      <span className="consultancy-summary-value">
                        <CountUp className="counter" end={totalPaid} />
                        <span className="consultancy-summary-unit">Tk</span>
                      </span>
                    </div>
                    <div className="consultancy-summary-tile">
                      <span className="consultancy-summary-label">
                        Buying cost
                      </span>
                      <span className="consultancy-summary-value">
                        <CountUp className="counter" end={buyingCost} />
                        <span className="consultancy-summary-unit">Tk</span>
                      </span>
                    </div>
                    <div className="consultancy-summary-tile consultancy-summary-tile--accent">
                      <span className="consultancy-summary-label">
                        Total profit
                      </span>
                      <span className="consultancy-summary-value">
                        <CountUp className="counter" end={totalProfit} />
                        <span className="consultancy-summary-unit">Tk</span>
                      </span>
                    </div>
                    <div className="consultancy-summary-tile consultancy-summary-tile--refund">
                      <span className="consultancy-summary-label">
                        Refund given
                      </span>
                      <span className="consultancy-summary-value">
                        <CountUp
                          className="counter"
                          end={summaryRefundGiven}
                          decimals={2}
                        />
                        <span className="consultancy-summary-unit">Tk</span>
                      </span>
                    </div>
                    <div className="consultancy-summary-tile consultancy-summary-tile--refund-taken">
                      <span className="consultancy-summary-label">
                        Refund taken
                      </span>
                      <span className="consultancy-summary-value">
                        <CountUp
                          className="counter"
                          end={summaryRefundTaken}
                          decimals={2}
                        />
                        <span className="consultancy-summary-unit">Tk</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div
                    className="card-header"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      borderBottom: "1px solid gainsboro",
                    }}
                  >
                    <h5>
                      <i
                        className="icofont-calendar"
                        style={{
                          fontSize: "130%",
                          marginRight: "5px",
                          color: "darkblue",
                        }}
                      ></i>
                      {this.props.match.params.month}
                    </h5>
                    <div>
                      <select
                        title="Filter by country"
                        required
                        name="filterCountry"
                        className="custom-select"
                        aria-required="true"
                        aria-invalid="false"
                        onChange={this.handleChange}
                        value={this.state.filterCountry}
                      >
                        <option value="">Filter by country </option>
                        <option value="">All</option>
                        <option value="INDIA">INDIA</option>
                        <option value="CHINA">CHINA</option>
                      </select>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="clearfix"></div>
                    <div id="basicScenario" className="product-physical">
                      <div className="table-responsive consultancy-invoice-table-wrap">
                      <table className="table table-bordered table-striped table-hover consultancy-invoice-table consultancy-invoice-table--agent">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Date</th>
                            <th scope="col">Agent</th>
                            <th scope="col">Customer</th>
                            <th scope="col">Product Name</th>
                          </tr>
                        </thead>
                        <tbody>
                          {renderablesourcings.map((sourcing, index) => (
                            <Fragment key={index}>
                              <tr className="consultancy-invoice-row">
                                <th
                                  scope="row"
                                  onClick={() => {
                                    this.props.history.push(
                                      `/business-consultancy/sourcing/${sourcing.id}`,
                                    );
                                  }}
                                >
                                  {index + 1}
                                </th>
                                <td
                                  onClick={() => {
                                    this.props.history.push(
                                      `/business-consultancy/sourcing/${sourcing.id}`,
                                    );
                                  }}
                                >
                                  {sourcing.date}
                                </td>
                                <td
                                  onClick={() => {
                                    this.props.history.push(
                                      `/business-consultancy/sourcing/${sourcing.id}`,
                                    );
                                  }}
                                >
                                  {sourcing.agent}
                                </td>
                                <td
                                  style={{
                                    maxWidth: 160,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                  title={sourcing.customer}
                                >
                                  {sourcing.customer}
                                </td>
                                <td
                                  style={{
                                    maxWidth: 180,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                  title={sourcing.productName}
                                  onClick={() => {
                                    this.props.history.push(
                                      `/business-consultancy/sourcing/${sourcing.id}`,
                                    );
                                  }}
                                >
                                  {sourcing.productName}
                                </td>
                              </tr>
                              <tr className="consultancy-invoice-detail-row">
                                <td colSpan={5}>
                                  <div className="consultancy-invoice-detail-layout">
                                    <div className="consultancy-invoice-chips">
                                      <span className="consultancy-chip">
                                        <span className="consultancy-chip-label">
                                          Total RMB
                                        </span>
                                        {sourcing.totalRmb || 0}Rmb
                                      </span>
                                      <span className="consultancy-chip">
                                        <span className="consultancy-chip-label">
                                          RMB Sell Rate
                                        </span>
                                        {sourcing.sellRate || 0}Tk
                                      </span>
                                      <span className="consultancy-chip">
                                        <span className="consultancy-chip-label">
                                          RMB Buy Rate
                                        </span>
                                        {sourcing.buyRate || 0}Tk
                                      </span>
                                      <span className="consultancy-chip">
                                        <span className="consultancy-chip-label">
                                          Total Bill
                                        </span>
                                        {sourcing.totalBill || 0}Tk
                                      </span>
                                      <span className="consultancy-chip">
                                        <span className="consultancy-chip-label">
                                          Total Paid
                                        </span>
                                        {sourcing.totalPaid || 0}Tk
                                      </span>
                                      <span className="consultancy-chip">
                                        <span className="consultancy-chip-label">
                                          Buying Cost
                                        </span>
                                        {sourcing.buyingCost || 0}Tk
                                      </span>
                                      <span className="consultancy-chip consultancy-chip--profit">
                                        <span className="consultancy-chip-label">
                                          Total Profit
                                        </span>
                                        {sourcing.finalProfit || 0}Tk
                                      </span>
                                      <span className="consultancy-chip consultancy-chip--profit">
                                        <span className="consultancy-chip-label">
                                          Agent Profit
                                        </span>
                                        {sourcing.agentPaid || 0}Tk
                                      </span>
                                      <span className="consultancy-chip consultancy-chip--profit">
                                        <span className="consultancy-chip-label">
                                          Zapai Profit
                                        </span>
                                        {sourcing.algProfit || 0}Tk
                                      </span>
                                      {(() => {
                                        const refundTotals =
                                          getRefundTotals(sourcing);
                                        return (
                                          <>
                                            {refundTotals.given > 0 && (
                                              <span className="consultancy-chip consultancy-chip--refund">
                                                <span className="consultancy-chip-label">
                                                  Refund Given
                                                </span>
                                                {refundTotals.given.toFixed(
                                                  2,
                                                )}
                                                Tk
                                              </span>
                                            )}
                                            {refundTotals.taken > 0 && (
                                              <span className="consultancy-chip consultancy-chip--refund-taken">
                                                <span className="consultancy-chip-label">
                                                  Refund Taken
                                                </span>
                                                {refundTotals.taken.toFixed(
                                                  2,
                                                )}
                                                Tk
                                              </span>
                                            )}
                                          </>
                                        );
                                      })()}
                                    </div>
                                    {currentAdmin ? (
                                      currentAdmin.status === "Admin" ||
                                      currentAdmin.status === "Accounts" ? (
                                        <div className="consultancy-invoice-actions">
                                          {sourcing.agentPaid ? (
                                            <span
                                              className="consultancy-chip consultancy-chip--action"
                                              style={{
                                                backgroundColor: "darkgreen",
                                              }}
                                              data-toggle="modal"
                                              data-target="#InvoiceInfoModal2"
                                              onClick={() => {
                                                this.setState({
                                                  sourcingObj: sourcing,
                                                  agentPaid: sourcing.finalProfit
                                                    ? Math.round(
                                                        sourcing.finalProfit *
                                                          (40 / 100),
                                                      )
                                                    : 0,
                                                });
                                              }}
                                            >
                                              <i className="icofont-tick-boxed" />{" "}
                                              Paid
                                            </span>
                                          ) : (
                                            <span
                                              className="consultancy-chip consultancy-chip--action"
                                              style={{
                                                backgroundColor: "darkorange",
                                              }}
                                              data-toggle="modal"
                                              data-target="#InvoiceInfoModal2"
                                              onClick={() => {
                                                this.setState({
                                                  sourcingObj: sourcing,
                                                  agentPaid: sourcing.finalProfit
                                                    ? Math.round(
                                                        sourcing.finalProfit *
                                                          (40 / 100),
                                                      )
                                                    : 0,
                                                });
                                              }}
                                            >
                                              <i className="icofont-tick-boxed" />{" "}
                                              Pay Now
                                            </span>
                                          )}
                                        </div>
                                      ) : null
                                    ) : null}
                                  </div>
                                </td>
                              </tr>
                            </Fragment>
                          ))}
                        </tbody>
                      </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <AllTransactions
                props={this.props}
                selectedTab={this.state.selectedTab}
                agent={this.props.match.params.agent}
                month={this.props.match.params.month}
              />
            )}
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}

        <div
          className="modal fade"
          id="InvoiceInfoModal2"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div className="modal-content responsive-modal consultancy-modal">
              <div className="modal-header">
                <div className="modal-title" id="exampleModalLabel">
                  Agent pay
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="consultancy-modal-summary">
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Invoice Id
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.id}
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Total{" "}
                      {sourcingObj && sourcingObj.country == "INDIA"
                        ? "rupees"
                        : "rmb"}
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.totalRmb}
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Buy rate
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.buyRate} Tk
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Sell rate
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.sellRate} Tk
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Total bill
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.totalBill} Tk
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Total paid
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {(sourcingObj && sourcingObj.totalPaid) || 0} Tk
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Buying cost
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {(sourcingObj && sourcingObj.buyingCost) || 0} Tk
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item consultancy-modal-summary-item--refund">
                    <span className="consultancy-modal-summary-label">
                      Refund given
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {totalRefundGiven} Tk
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Refund received
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {totalRefundReceived}{" "}
                      {sourcingObj && sourcingObj.country == "INDIA"
                        ? "rupees"
                        : "rmb"}{" "}
                      * {sourcingObj && sourcingObj.buyRate} ={" "}
                      {totalRefundReceivedTk} Tk
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Other charges
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {totalOtherCharges}{" "}
                      {sourcingObj && sourcingObj.country == "INDIA"
                        ? "rupees"
                        : "rmb"}{" "}
                      * {sourcingObj && sourcingObj.buyRate} ={" "}
                      {totalOtherChargesTk} Tk
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item consultancy-modal-summary-item--accent">
                    <span className="consultancy-modal-summary-label">
                      Total profit
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj &&
                        sourcingObj.finalProfit +
                          totalRefundReceivedTk -
                          totalRefundGiven -
                          totalOtherChargesTk}{" "}
                      Tk
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item">
                    <span className="consultancy-modal-summary-label">
                      Agent profit
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj && sourcingObj.agentPaid} Tk
                    </span>
                  </div>
                  <div className="consultancy-modal-summary-item consultancy-modal-summary-item--accent">
                    <span className="consultancy-modal-summary-label">
                      Zapai profit
                    </span>
                    <span className="consultancy-modal-summary-value">
                      {sourcingObj &&
                        sourcingObj.finalProfit +
                          totalRefundReceivedTk -
                          totalRefundGiven -
                          totalOtherChargesTk -
                          sourcingObj.agentPaid}{" "}
                      Tk
                    </span>
                  </div>
                </div>

                <div
                  className={`consultancy-modal-callout${
                    sourcingObj && sourcingObj.agentPaid
                      ? " consultancy-modal-callout--paid"
                      : ""
                  }`}
                >
                  <div>
                    <div className="consultancy-modal-callout-label">
                      {sourcingObj && sourcingObj.agentPaid
                        ? "Already paid to agent"
                        : "Agent pay (40% of total profit)"}
                    </div>
                    <div className="consultancy-modal-callout-value">
                      {sourcingObj && sourcingObj.agentPaid
                        ? sourcingObj.agentPaid
                        : this.state.agentPaid}{" "}
                      Tk
                    </div>
                  </div>
                  {!(sourcingObj && sourcingObj.agentPaid) && (
                    <span className="consultancy-modal-callout-note">
                      This amount will be cashed out to the agent when you
                      confirm below.
                    </span>
                  )}
                </div>
                {sourcingObj &&
                  sourcingObj.agentPays &&
                  sourcingObj.agentPays.length > 0 && (
                    <div className="form-group" style={{ marginBottom: 0 }}>
                      <label
                        style={{
                          fontWeight: "bold",
                          color: "#505050",
                          marginBottom: 5,
                        }}
                      >
                        Previous agent payment
                      </label>
                      <table className="table table-bordered table-striped table-hover">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Amount</th>
                            <th>Entry By</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sourcingObj.agentPays
                            .sort((a, b) => a.id - b.id)
                            .map((refund) => (
                              <tr>
                                <td>{refund.date}</td>
                                <td>{refund.amount} Tk</td>
                                <td>{refund.expenseBy}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  )}
              </div>
              <div className="modal-footer">
                {sourcingObj && sourcingObj.agentPaid ? null : (
                  <button
                    type="button"
                    className="btn"
                    data-dismiss="modal"
                    style={{
                      backgroundColor: "#c2410c",
                      color: "white",
                    }}
                    onClick={() => {
                      this.handleCashOut(sourcingObj);
                    }}
                  >
                    Cash Out
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    sourcings: state.sourcings.sourcings,
    allEmployees: state.employees.employees.filter(
      (employee) => employee.status == "Active",
    ),
    currentAdmin: state.admins.currentAdmin,
  };
};

export default connect(mapStateToProps, {
  getAllSourcingsAgentRedux,
  getAllEmployeeRedux,
  handleSourcingAgentPayRedux,
})(MonthlyInvoices);
